import { render } from "./industryTemplate.vue?vue&type=template&id=4b30974a&scoped=true"
import script from "./industryTemplate.vue?vue&type=script&lang=js"
export * from "./industryTemplate.vue?vue&type=script&lang=js"

import "./industryTemplate.vue?vue&type=style&index=0&id=4b30974a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4b30974a"

export default script